import { FC } from "react";
import { DeepMap, FieldError } from "@hookform/error-message/dist/types";
import { nameof } from "../../../utils/Helpers";
import { LessonTopicPageInstructionModel } from "../../../models/crud/lessontopicpageinstructions/LessonTopicPageInstructionModel";
import { RichTextEditor } from "../RichTextEditor";

type Props = {
    errors: DeepMap<Record<string, any>, FieldError>;
    register: <HTMLTextareaElement>(refOrValidationOptions: HTMLTextareaElement) => void | ((ref: HTMLTextareaElement | null) => void);
}

export const FieldLessonTopicPageInstructionBody: FC<Props> = (props: Props) => {
    const { errors, register } = props;

    const nameBody = nameof<LessonTopicPageInstructionModel>("Body");

    return <RichTextEditor name={nameBody} register={register} errors={errors} />;
}